import router from '@/router';
import business from '@/router/moudles/business.js';
import report from '@/router/moudles/report.js';
import baseData from '@/router/moudles/baseData.js';
import system from '@/router/moudles/system.js';
import platform from '@/router/moudles/platform.js';



/* 打开的面板 */
const state = {
  // 可以在多页 tab 模式下显示的页面
  pool: [],
  opened:[
    {
      path:'/',
      fullPath:'/',
      name:"home",
      meta:{title:"首页"}
    }
  ],//当前打开面板
  current:'home'//当前打开页，默认首页
};
const mutations = {
  /**
   * @class current
   * @description 设置当前激活的页面 fullPath
   * @param {Object} state state
   * @param {String} fullPath new fullPath
   */
  currentSet (state, {name,fullPath}) {
    state.current = name;
  },
};

const actions = {
  /**
   * @class pool
   * @description 保存 pool (候选池)
   * @param {Object} state state
   */
  init({state,commit,dispatch}){
    //所有路由
    let allRoutes = [];
    const setRoutes = function(arr){
      arr.forEach(item=>{
        allRoutes.push(item);
        if(item.children){
          setRoutes(arr.children);
        }
      });
    };
    const addRoutes = function(res){
      allRoutes.push(res);
      if(res.children){
        setRoutes(res.children);
      }
    };

    addRoutes(business);
    addRoutes(report);
    addRoutes(baseData);
    addRoutes(system);
    addRoutes(platform);

    //console.log(allRoutes,'====== 所有路由 =');

    const pool = [];
    const push = function(allRoutes){
      allRoutes.forEach(route => {
        if (route.children && route.children.length > 0) {
          push(route.children)
        } else {
          if(!route.meta.hidden){
            const { meta, name, path } = route;
            pool.push({ meta, name, path });
          }
          /* if (!route.hidden) {
            const { meta, name, path } = route;
            pool.push({ meta, name, path });
          } */
        }
      });
    };
    push(allRoutes);
    state.pool = pool;
    //console.log(pool,'==  4546 ===');

  },
  /**
   * @class opened
   * @description 新增一个 tag (打开一个页面)
   * @param {Object} context
   * @param {Object} payload new tag info
   */
  add ({ state, commit, dispatch }, {name,meta,params,query,fullPath}) {
    let newTag = {};
    newTag.name = name || '';
    newTag.meta = meta || {};
    newTag.params = params || {};
    newTag.query = query || {};
    newTag.fullPath = fullPath || '';
    console.log(newTag);
    // 添加进当前显示的页面数组
    state.opened.push(newTag);
  },

  /**
   * @class current
   * @description 打开一个新的页面
   * @param {Object} context
   */
  open({state,dispatch,commit},res){
    if(!state.pool.length) dispatch('init');
    if(res) return;
    //当前打开的
    const {name,meta,params,query,fullPath} = router.app.$route;

    // 已经打开的页面
    let opened = state.opened;
    // 判断此页面是否已经打开 并且记录位置
    let pageOpendIndex = 0;
    const pageOpend = opened.find((page, index) => {
      const same = page.name === name
      pageOpendIndex = same ? index : pageOpendIndex
      return same
    });

    //打开过
    if(pageOpend){
      commit('currentSet',pageOpend);
      console.log(' 打开过 ');
    }else{//没打开过
      // 页面以前没有打开过
      let page = state.pool.find(t => t.name === name);
      if(page){
        dispatch('add',{name,meta,params,query,fullPath});
        commit('currentSet',{name,meta,params,query,fullPath});
      }
    }
    //commit('open');
  },
  /**
   * @class opened
   * @description 关闭一个 tag (关闭一个页面)
   * @param {Object} context
   * @param {Object} payload { tagName: 要关闭的标签名字 }
   */
  close ({ state, commit, dispatch }, { tagName }) {
    // 下个新的页面
    let newPage = state.opened[0];//默认是首页
    const isCurrent = state.current === tagName;
    // 如果关闭的页面就是当前显示的页面
    if (isCurrent) {
      // 去找一个新的页面
      let len = state.opened.length;
      for (let i = 1; i < len; i++) {
        if (state.opened[i].name === tagName) {
          if (i < len - 1) {
            newPage = state.opened[i + 1]
          } else {
            newPage = state.opened[i - 1]
          }
          break
        }
      }
    }
    // 找到这个页面在已经打开的数据里是第几个
    const index = state.opened.findIndex(page => page.name === tagName)
    if (index >= 0) {
      // 更新数据 删除关闭的页面
      state.opened.splice(index, 1)
    }
    // 最后需要判断是否需要跳到首页
    if (isCurrent) {
      const { name = '', params = {}, query = {} } = newPage
      let routerObj = {
        name,
        params,
        query
      }
      router.push(routerObj);
    };
  },

  /**
   * @class opened
   * @description 关闭当前激活之外的 tag
   * @param {Object} context
   * @param {Object} payload { pageSelect: 当前选中的tagName }
   */
  closeOther ({ state, commit, dispatch }) {
    const pageAim = state.current;
    // 找到这个页面在已经打开的数据里是第几个
    const currentIndex = state.opened.findIndex(page => page.name === pageAim);

    // 删除打开的页面数据
    if(currentIndex === 0){
      state.opened.splice(1, state.opened.length-1);
    }else{
      let nowCurrentIndex = currentIndex+1;
      let rightNum = state.opened.length - nowCurrentIndex;
      let leftNum = currentIndex-1;
      state.opened.splice(nowCurrentIndex,rightNum);
      state.opened.splice(1,leftNum);
    }
  },
  /**
   * @class opened
   * @description 关闭所有 tag
   * @param {Object} context
   */
  closeAll ({ state, commit, dispatch }) {
    // 关闭所有的标签页后需要判断一次现在是不是在首页
    //console.log(router.app.$route.name,66666,'================');
    state.opened.splice(1, state.opened.length-1);
    if (router.app.$route.name !== 'home') {
      router.push({
        name: 'home'
      })
    }
  }

};

export default{
  namespaced: true,
  state,mutations,actions
}
